var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 35,
    viewBox: "0 0 26 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08922 30.4417C0.721219 32.3137 0.259219 34.2217 0.199219 34.9417L24.4992 34.9417C24.3792 34.3717 23.3292 32.5657 20.0892 29.9017C16.0392 26.5717 17.1192 25.8517 17.6592 25.4917C18.1992 25.1317 18.1092 24.5917 18.3792 24.1417C19.0092 23.3317 20.2692 23.8717 22.2492 24.1417C24.2292 24.4117 23.7792 22.6117 23.6892 21.6217C23.5992 20.6317 24.4092 20.4517 24.5892 20.1817C24.7692 19.9117 24.6792 19.6417 24.3192 19.3717C24.5892 19.3717 24.6792 19.1917 24.8592 19.0117C24.9312 18.2197 24.6492 17.4217 24.4992 17.1217C24.6192 17.0617 24.9852 16.8697 25.4892 16.5817C26.1192 16.2217 26.0292 15.8617 25.6692 15.3217C25.3092 14.7817 24.1392 12.4417 24.3192 12.0817C25.2192 10.1917 24.3192 7.31173 23.7792 5.42173C25.1472 3.69373 24.0492 2.30173 23.3292 1.82173C23.4192 1.97173 23.4372 2.45173 22.7892 3.17173C23.1492 1.19173 19.1892 0.921733 17.7492 0.831719C11.8992 0.561719 7.66922 2.00172 5.68922 5.78172C3.70922 9.56172 5.05922 13.8817 6.40922 16.8517C7.75922 19.8217 7.57922 23.2417 6.40922 24.7717C5.23922 26.3017 3.79922 28.1017 2.08922 30.4417Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.9fbcbab310e3ab05b90b831c283d1867.svg";
export { ForwardRef as ReactComponent };